import { PolygonSides } from '../../utils/editorReactIcons';
export { PolygonSides };
export default PolygonSides;
